'use strict';

export default class TwoColAccordion {
  constructor($selector, selfInit = true) {
    this.$selector = $selector;
    this.$toggleBtn = $('.two-col-accordion__toggle-btn', this.$selector);
    this.isExpanded = this.$selector.hasClass('expanded') ? true : false;

    if(selfInit) this.init($selector);
  }

  init() {
    this.$toggleBtn.on('click', (e) => {
      if (this.isExpanded) {
        $('.two-col-accordion__right', this.$selector).slideUp();
        this.isExpanded = false;

        this.$toggleBtn.attr('aria-expanded', this.isExpanded);
        this.$selector.removeClass('expanded');
      } else {
        $('.two-col-accordion__right', this.$selector).slideDown();
        this.isExpanded = true;
        this.$selector.addClass('expanded');
      }

      this.$toggleBtn.attr('aria-expanded', this.isExpanded);
    });

    $('.read-more-content', this.$selector).map((i, ele) => {
      let charLimit = $(ele).data('limit') ? $(ele).data('limit') : 400;
      let expandLabel = $(ele).data('expandlabel') ? $(ele).data('expandlabel') : 'Read more';
      let collapseLabel = $(ele).data('collapselabel') ? $(ele).data('collapselabel') : 'View less';
      if ($(ele).text().length > charLimit) {
        let visibleText = $(ele).text().substring(0, charLimit);
        let hiddenText = $(ele).text().substring(charLimit);

        $(ele).html(visibleText + '<span class="ellipsis">...</span><span class="more-text" style="display:none;">' + hiddenText + '</span>');
        $(ele).after('<button class="read-more-btn" type="button">' + expandLabel + '</button>');
      }

      $(ele).parent().on('click', '.read-more-btn', (e)=> {
        let $btn = $(e.currentTarget);
        let isExpanded = $btn.text() === collapseLabel;

        if (isExpanded) {
          $(ele).find(".more-text").fadeOut(300);
          $(ele).find('.ellipsis').fadeIn()
          
        } else {
          $(ele).find('.ellipsis').hide();
          $(ele).find(".more-text").fadeIn(300);
        }

        //$(ele).find('.ellipsis, .more-text').toggle();
        $btn.text($btn.text() === expandLabel ? collapseLabel : expandLabel);
      });
    });
  }
}
